// "use client";
//
// import Logo from "@/components/logo";
// import logoImage from "@public/svg/logo-2.svg";
// import { IBaseLabelValue, IInquiryDetailsResultValues } from "@/interfaces";
// import { convertToJalaliDateTime } from "@/lib";
// import { QRCodeCanvas } from "qrcode.react";
//
// interface IProps {
//   resultContent: IBaseLabelValue[] | string[][] | IInquiryDetailsResultValues[];
//   tableTitle?: string;
//   dateTime: string;
//   code?: string;
// }
//
// const PdfTemplate = (props: IProps) => {
//   // Filter out empty rows (keep rows that have at least a title/label)
//   const filteredContent = props.resultContent.filter((item) => {
//     if (Array.isArray(item)) {
//       const value = item[1];
//       return item[0] && value !== "-";
//     }
//
//     const value = item.value;
//     return item.label && value !== "-";
//   });
//
//   // Split content into chunks for pagination (adjust items per page as needed)
//   const itemsPerPage = 12; // Reduced from 15 to fit better with spacing
//   const pageCount = Math.ceil(filteredContent.length / itemsPerPage);
//   const pages = Array.from({ length: pageCount }, (_, pageIndex) => {
//     const start = pageIndex * itemsPerPage;
//     const end = start + itemsPerPage;
//     return filteredContent.slice(start, end);
//   });
//
//   return (
//     <>
//       <style>
//         {`
//           @media print {
//             .pdf-page {
//               page-break-after: always;
//               page-break-inside: avoid;
//             }
//             .pdf-page:last-child {
//               page-break-after: auto;
//             }
//           }
//         `}
//       </style>
//       {pages.map((pageContent, pageIndex) => (
//         <section
//           key={pageIndex}
//           className="pdf-page"
//           style={{
//             position: "relative",
//             minHeight: "1100px",
//             height: "1100px",
//             display: "flex",
//             flexDirection: "column",
//             margin: "20px",
//             pageBreakAfter: pageIndex < pages.length - 1 ? "always" : "auto",
//           }}
//         >
//           {/* Watermark on every page */}
//           <div
//             style={{
//               position: "absolute",
//               top: "0",
//               left: "0",
//               right: "0",
//               bottom: "0",
//               backgroundImage: `url("${logoImage.src}")`,
//               backgroundRepeat: "no-repeat",
//               backgroundPosition: "center center",
//               backgroundSize: "contain",
//               opacity: 0.04,
//               pointerEvents: "none",
//               zIndex: 1,
//             }}
//           />
//
//           <div
//             style={{
//               position: "relative",
//               zIndex: 50,
//               flex: "1",
//               display: "flex",
//               flexDirection: "column",
//             }}
//           >
//             {/* Header on every page */}
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 marginBottom: "10px",
//                 gap: "1rem",
//               }}
//             >
//               <Logo width={80} height={80} src={logoImage} />
//               <span
//                 style={{
//                   fontSize: "1.25rem",
//                   fontWeight: "bold",
//                   marginBottom: "28px",
//                 }}
//               >
//                 گزارش استعلام رسمی از سامانه نوین وان
//               </span>
//               {props.dateTime && (
//                 <div style={{ display: "flex", flexDirection: "column" }}>
//                   <span style={{ fontSize: "14px" }}>زمان/تاریخ</span>
//                   <span
//                     dir="ltr"
//                     style={{ marginTop: "8px", fontWeight: "bold" }}
//                   >
//                     {convertToJalaliDateTime(props.dateTime)}
//                   </span>
//                 </div>
//               )}
//             </div>
//             <hr style={{ color: "#ccc" }} />
//
//             {/* Content */}
//             <div
//               style={{
//                 marginTop: "2rem",
//                 flex: "1",
//                 maxHeight: "800px",
//                 overflow: "hidden",
//               }}
//             >
//               <h2
//                 style={{
//                   textAlign: "center",
//                   marginTop: "8px",
//                   marginBottom: "16px",
//                   fontSize: "18px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 {props.tableTitle}
//                 {pages.length > 1 &&
//                   ` (صفحه ${pageIndex + 1} از ${pages.length})`}
//               </h2>
//               <table
//                 style={{
//                   width: "100%",
//                   borderCollapse: "collapse",
//                   border: "1px solid #ccc",
//                   margin: "8px 0",
//                 }}
//               >
//                 <thead>
//                   <tr>
//                     <th
//                       style={{
//                         textAlign: "center",
//                         padding: "0 8px",
//                         border: "1px solid #ccc",
//                         fontSize: "16px",
//                         paddingBottom: "16px",
//                       }}
//                     >
//                       <p style={{ marginBottom: "0" }}>عنوان</p>
//                     </th>
//                     <th
//                       style={{
//                         textAlign: "center",
//                         padding: "0 8px",
//                         paddingBottom: "16px",
//                         border: "1px solid #ccc",
//                       }}
//                     >
//                       <p style={{ marginBottom: "0" }}>نتیجه</p>
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {pageContent.map((item, i) => (
//                     <tr key={i}>
//                       <td
//                         style={{
//                           padding: "0 8px",
//                           border: "1px solid #ccc",
//                           paddingBottom: "16px",
//                         }}
//                       >
//                         <p style={{ marginBottom: "0" }}>
//                           {Array.isArray(item) ? item[0] : item.label}
//                         </p>
//                       </td>
//                       <td
//                         style={{
//                           padding: "0 8px",
//                           border: "1px solid #ccc",
//                           paddingBottom: "16px",
//                         }}
//                       >
//                         <p style={{ marginBottom: "0" }}>
//                           {Array.isArray(item) ? item[1] : item.value}
//                         </p>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//
//           {/* Footer on every page */}
//           <div
//             style={{
//               width: "100%",
//               marginTop: "auto",
//               position: "relative",
//               zIndex: 50,
//             }}
//           >
//             <hr />
//             <footer
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 width: "100%",
//                 padding: "1rem",
//               }}
//             >
//               <p style={{ margin: 0, fontSize: "14px", lineHeight: "30px" }}>
//                 این گزارش توسط سامانه استعلامات نوین وان (novin.one) تولید شده
//                 است.
//                 <br />
//                 اعتبار این استعلام را می‌توانید در بخش{" "}
//                 <b>"تأیید اصالت گزارش"</b> سایت بررسی کنید.
//               </p>
//               {props.code && (
//                 <div style={{ display: "flex" }}>
//                   <div
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       justifyContent: "center",
//                     }}
//                   >
//                     <span style={{ color: "#AAAAAA", fontSize: "14px" }}>
//                       شناسه اصالت گزارش
//                     </span>
//                     <span
//                       className="text-en"
//                       style={{
//                         color: "#D32F2F",
//                         fontWeight: "bold",
//                         fontSize: "26px",
//                         letterSpacing: "1px",
//                       }}
//                     >
//                       {props.code}
//                     </span>
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       position: "relative",
//                     }}
//                   >
//                     <div style={{ width: "100px", height: "100px" }}>
//                       <QRCodeCanvas
//                         value={`https://novin.one/inquiry-validity?code=${props.code}`}
//                         size={100}
//                         level="H"
//                         marginSize={3}
//                       />
//                     </div>
//                     <div
//                       style={{
//                         position: "absolute",
//                         left: "-40px",
//                         top: "50%",
//                         transform: "translateY(-50%) rotate(-90deg)",
//                         transformOrigin: "center center",
//                         fontSize: "12px",
//                         color: "#AAAAAA",
//                         whiteSpace: "nowrap",
//                       }}
//                     >
//                       اسکن کنید
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </footer>
//           </div>
//         </section>
//       ))}
//     </>
//   );
// };
// export default PdfTemplate;
"use client";

import Logo from "@/components/logo";
import logoImage from "@public/svg/logo-2.svg";
import { IBaseLabelValue, IInquiryDetailsResultValues } from "@/interfaces";
import { convertToJalaliDateTime } from "@/lib";
import { QRCodeCanvas } from "qrcode.react";

interface IProps {
  resultContent: IBaseLabelValue[] | string[][] | IInquiryDetailsResultValues[];
  tableTitle?: string;
  dateTime: string;
  code?: string;
  itemsPerPage?: number;
}

const PdfTemplate = (props: IProps) => {
  // Filter out empty rows (keep rows that have at least a title/label)
  const filteredContent = props.resultContent.filter((item) => {
    if (Array.isArray(item)) {
      const value = item[1];
      return item[0] && value !== "-";
    }

    const value = item.value;
    return item.label && value !== "-";
  });

  // Split content into chunks for pagination (adjust items per page as needed)
  const itemsPerPage = 10; // Reduced to ensure all items fit on each page
  const pageCount = Math.ceil(filteredContent.length / itemsPerPage);
  const pages = Array.from({ length: pageCount }, (_, pageIndex) => {
    const start = pageIndex * itemsPerPage;
    const end = start + itemsPerPage;
    return filteredContent.slice(start, end);
  });

  return (
    <>
      <style>
        {`
          @media print {
            .pdf-page {
              page-break-after: always;
              page-break-inside: avoid;
              margin: 0;
              padding: 20px;
            }
            .pdf-page:last-child {
              page-break-after: auto;
            }
            @page {
              margin: 20px;
            }
          }
        `}
      </style>
      {pages.map((pageContent, pageIndex) => (
        <section
          key={pageIndex}
          className="pdf-page"
          style={{
            position: "relative",
            minHeight: "1100px",
            display: "flex",
            flexDirection: "column",
            margin: "20px",
            padding: "20px",
            paddingBottom: "40px",
            pageBreakAfter: pageIndex < pages.length - 1 ? "always" : "auto",
            pageBreakInside: "avoid",
          }}
        >
          {/* Watermark on every page */}
          <div
            style={{
              position: "absolute",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
              backgroundImage: `url("${logoImage.src}")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
              backgroundSize: "contain",
              opacity: 0.04,
              pointerEvents: "none",
              zIndex: 1,
            }}
          />

          <div
            style={{
              position: "relative",
              zIndex: 50,
              flex: "1",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Header on every page */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "10px",
                paddingBottom: "10px",
                gap: "1rem",
                pageBreakInside: "avoid",
              }}
            >
              <Logo width={80} height={80} src={logoImage} />
              <span
                style={{
                  fontSize: "1.25rem",
                  fontWeight: "bold",
                  marginBottom: "28px",
                }}
              >
                گزارش استعلام رسمی از سامانه نوین وان
              </span>
              {props.dateTime && (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span style={{ fontSize: "14px" }}>زمان/تاریخ</span>
                  <span
                    dir="ltr"
                    style={{ marginTop: "8px", fontWeight: "bold" }}
                  >
                    {convertToJalaliDateTime(props.dateTime)}
                  </span>
                </div>
              )}
            </div>
            <hr style={{ color: "#ccc", marginBottom: "10px" }} />

            {/* Content */}
            <div
              style={{
                marginTop: "2rem",
                flex: "1",
              }}
            >
              <h2
                style={{
                  textAlign: "center",
                  marginTop: "8px",
                  marginBottom: "16px",
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
              >
                {props.tableTitle}
                {pages.length > 1 &&
                  ` (صفحه ${pageIndex + 1} از ${pages.length})`}
              </h2>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  border: "1px solid #ccc",
                  margin: "8px 0",
                }}
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        textAlign: "center",
                        padding: "0 8px",
                        border: "1px solid #ccc",
                        fontSize: "16px",
                        paddingBottom: "16px",
                        width: "30%",
                      }}
                    >
                      <p style={{ marginBottom: "0" }}>عنوان</p>
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        padding: "0 8px",
                        paddingBottom: "16px",
                        border: "1px solid #ccc",
                        width: "70%",
                      }}
                    >
                      <p style={{ marginBottom: "0" }}>نتیجه</p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {pageContent.map((item, i) => (
                    <tr key={i}>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ccc",
                          wordWrap: "break-word",
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          paddingBottom: "20px",
                        }}
                      >
                        <p style={{ marginBottom: "0", lineHeight: "1.8" }}>
                          {Array.isArray(item) ? item[0] : item.label}
                        </p>
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ccc",
                          wordWrap: "break-word",
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          paddingBottom: "20px",
                        }}
                      >
                        <p style={{ marginBottom: "0", lineHeight: "1.8" }}>
                          {Array.isArray(item) ? item[1] : item.value}
                        </p>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Footer on every page */}
          <div
            style={{
              width: "100%",
              marginTop: "auto",
              position: "relative",
              zIndex: 50,
              paddingTop: "20px",
              pageBreakInside: "avoid",
            }}
          >
            <hr style={{ marginBottom: "10px" }} />
            <footer
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                padding: "1rem",
                pageBreakInside: "avoid",
              }}
            >
              <p style={{ margin: 0, fontSize: "14px", lineHeight: "30px" }}>
                این گزارش توسط سامانه استعلامات نوین وان (novin.one) تولید شده
                است.
                <br />
                اعتبار این استعلام را می‌توانید در بخش{" "}
                <b>"تأیید اصالت گزارش"</b> سایت بررسی کنید.
              </p>
              {props.code && (
                <div style={{ display: "flex" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <span style={{ color: "#AAAAAA", fontSize: "14px" }}>
                      شناسه اصالت گزارش
                    </span>
                    <span
                      className="text-en"
                      style={{
                        color: "#D32F2F",
                        fontWeight: "bold",
                        fontSize: "26px",
                        letterSpacing: "1px",
                      }}
                    >
                      {props.code}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    <div style={{ width: "100px", height: "100px" }}>
                      <QRCodeCanvas
                        value={`https://novin.one/inquiry-validity?code=${props.code}`}
                        size={100}
                        level="H"
                        marginSize={3}
                      />
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        left: "-40px",
                        top: "50%",
                        transform: "translateY(-50%) rotate(-90deg)",
                        transformOrigin: "center center",
                        fontSize: "12px",
                        color: "#AAAAAA",
                        whiteSpace: "nowrap",
                      }}
                    >
                      اسکن کنید
                    </div>
                  </div>
                </div>
              )}
            </footer>
          </div>
        </section>
      ))}
    </>
  );
};
export default PdfTemplate;
